import ReadMore from './ReadMore';

export default ReadMore;
